/**
  * 用户 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
 const index = {
    // 我的优惠券列表
    couponList (params) {
        return axios.get('/home/user/center/quan', { params: params })
        // return axios.post('/home/user/center/quan', qs.stringify(params))
    },
    // 头条评论
    headlinesList (params) {
        return axios.get('/home/user/center/headlines', { params: params })
        // return axios.post('/home/user/center/headlines', qs.stringify(params))
    },
    // 商品评论
    goodsCommentList (params) {
        return axios.get('/home/user/center/goods', { params: params })
        // return axios.post('/home/user/center/headlines', qs.stringify(params))
    },
    // 项目评论
    itemCommentList (params) {
        return axios.post('/home/itemAbout/userComments', qs.stringify(params))
        // return axios.post('/home/user/center/headlines', qs.stringify(params))
    },
    // 消费记录
    tradeRecord (params) {
        return axios.get('/home/user/center/traderecord', { params: params })
        // return axios.post('/home/user/center/traderecord', qs.stringify(params))
    },
    // 商品收藏列表
    goodsCollectionList (params) {
        return axios.get('/home/user/center/collectgood', { params: params })
    },
    // 专题收藏列表
    specialCollectionList (params) {
        return axios.get('/home/user/center/collectspecial', { params: params })
    },
    // 头条收藏列表
    headlineCollectionList (params) {
        return axios.get('/home/user/center/collectheadline', { params: params })
    },
    // 城市合伙人首页
    partnerIndex (params) {
        return axios.get('/home/user/partner/list', { params: params })
    },
    // 代理商首页
    agentIndex (params) {
        return axios.get('/home/user/agent/list', { params: params })
    },
    // 银行卡列表
    bankList (params) {
        return axios.get('/home/user/bank/list', { params: params })
    },
    // 添加银行卡
    bankAdd (params) {
        return axios.post('/home/user/bank/create', qs.stringify(params))
    },
    // 银行卡详情
    bankDetail (params) {
        return axios.get('/home/user/bank/detail', { params: params })
    },
    // 编辑银行卡
    bankEdit (params) {
        return axios.post('/home/user/bank/edit', qs.stringify(params))
    },
    // 删除银行卡
    bankDelete (params) {
        return axios.post('/home/user/bank/remove', qs.stringify(params))
    },
    //代理商可添加商家列表
    agentTradesman (params) {
        return axios.get('/home/agent/unbind/tradesman', { params: params })
    },
    //代理商添加商家
    agentAddTradesman (params) {
        return axios.post('/home/user/agent/createtradesman', qs.stringify(params))
    },
    //代理商商家排序
    agentTradesmanOrder (params) {
        return axios.post('/home/user/agent/tradesman-post', qs.stringify(params))
    },
    //代理商二维码展示
    agentQRCode (params) {
        return axios.get('/home/user/agent/tradesman-detail', { params: params })
    },
    //代理商发展会员
    agentUser (params) {
        return axios.get('/home/user/agent/user-list', { params: params })
    },
    //代理商/城市合伙人收入明细
    incomeList (params) {
        return axios.get('/home/user/income/data', { params: params })
    },  
    //提现明细
    withdrawList (params) {
        return axios.get('/home/user/tx/data', { params: params })
    },
    //提现
    withdraw (params) {
        return axios.post('/home/user/apply/money', qs.stringify(params))
    }, 
    //用户信息详情
    info (params) {
        return axios.get('/home/user/seting/detail', { params: params })
    },
    //修改头像
    thumb (params) {
        return axios.post('/home/user/seting/thumb-edit', qs.stringify(params))
    },    
    //修改手机号
    phone (params) {
        return axios.post('/home/user/seting/phone-edit', qs.stringify(params))
    },    
    //修改昵称
    nickname (params) {
        return axios.post('/home/user/seting/nickname-edit', qs.stringify(params))
    },    
    //修改密码
    password (params) {
        return axios.post('/home/user/seting/pwd-edit', qs.stringify(params))
    },
    //申请成为经销商
    applySeller (params) {
        return axios.post('/home/user/seller/apply', qs.stringify(params))
    }, 
    //申请成为匠人
    applyTradesman (params) {
        return axios.post('/home/user/tradesman/apply', qs.stringify(params))
    },   
    //粉丝列表
    fansList (params) {
        return axios.get('/home/user/center/attentionme', { params: params })
    },
    //关注列表
    attentionList (params) {
        return axios.get('/home/user/center/meattention', { params: params })
    },   
    // 获取申请角色的审核状态
    roleStatus (params) {
        return axios.get('/home/userrole/status', { params: params })
    },
    // 员工是否认证
    staffIsAuth (params) {
        return axios.get('/home/user/staff/isauth', { params: params })
    },
    // 员工是否可以认证
    staffVerify (params) {
        return axios.get('/home/user/staff/verify', { params: params })
    },
    // 员工认证
    staffAuth (params) {
        return axios.post('/home/user/staff/auth', qs.stringify(params))
    },
    // 充值卡列表
    cardList (params) {
        return axios.get('/home/user/card/list', { params: params })
    },
    // 充值卡消费列表
    cardShow (params) {
        return axios.get('/home/user/card/show', { params: params })
    }, 
    // 绑定充值卡
    bindCard (params) {
        return axios.post('/home/user/card/bind', qs.stringify(params))
    }, 
    // 解绑员工
    unBindStaff (params) {
        return axios.post('/home/user/card/unbind', qs.stringify(params))
	},  
    // 申请代理商
    applyAgent  (params) {
        return axios.post('/home/user/agent/apply', qs.stringify(params))
    },  
    partnerApply(params) {
        return axios.post('/home/user/partner/apply', qs.stringify(params))
    },  
	// 单页 各类协议等
	singlePage(params){
		return axios.get('/home/page', { params: params })
	},
	// 代理商清除会员
	agentDelte(params){
		return axios.post('/home/user/agent/delete', qs.stringify(params))
	},
	// 供应商信息
	btobInfo(params){
		// 原接口 home/user/seller/list
		return axios.post('/home/user/seller/center', qs.stringify(params))
	},
	// 用户进入直播间
	living(params){
		return axios.get('/home/liveroom/living', { params: params })
	},
	// 查询供应商审核信息
    sellerDetail(params) {
		return axios.get('/home/seller/shenHeDetail', { params: params })
	},
	// 申请一级分销商(也就是一级代理商)
	applyFirstAgent  (params) {
        return axios.post('/home/user/firstagent/apply', qs.stringify(params))
	},
	// 一级经销商首页
	firstAgentIndex (params) {
        return axios.get('/home/user/firstagent/index', { params: params })
	},
	// 一级经销商列表
	firstAgentList (params) {
        return axios.get('/home/user/firstagent/list', { params: params })
	},
	// 定制收藏列表
	dingzhiCollectionList (params) {
        return axios.get('/home/user/center/custommade', { params: params })
	},
	// 绑园区充值卡
	bindParkCard(params){
		return axios.post('/home/user/parkcard/bind', qs.stringify(params))
	},
	// 园区卡列表
	parkCardList (params) {
        return axios.get('/home/user/parkcard/list', { params: params })
	},
	// 园区卡消费列表
	parkCardShow (params) {
        return axios.get('/home/user/parkcard/show', { params: params })
    },
	// 足迹
	lookrecord(params){
		return axios.get('/home/user/lookrecord', { params: params })
	},
	// 删除足迹
	dellookrecord(params){
		return axios.post('/home/del/lookrecord', qs.stringify(params))
	},
	// 数字藏品的支付
	paycangpin(params){
		return axios.get("/numpro/product/topay", { params: params });
	},
	// 判断是否为 iyiqi的用户
	isiyiqiuser(params){
		return axios.get("/home/iyiqi/isuser", { params: params });
	},
	// 积分消费记录
	pointlist(params){
		return axios.get("/home/user/pointlist", { params: params });
	}
 }
 
 // 导出接口
 export default index